export default "__VITE_ASSET__B$WuHw2E__"